import { AuthProvider } from "./context/auth";
import { DirtyProvider } from "./context/dirty";
import { Navigate, Route, Routes } from "react-router-dom";
import { Dashboard } from "./pages/Dashboard";
import { Login } from "./pages/Login";
import { Newfile } from "./pages/NewFile";
import { History } from "./pages/record-v2";
import { Newuser } from "./pages/NewUser";
import { ListUsers } from "./pages/ListUsers";
import { PDFViewer } from "./pages/PDFViewer";
import { Customers } from "./pages/Customers";
import { NewCustomer } from "./pages/Customers/new";
import { EditCustomer } from "./pages/Customers/edit";
import { Patent } from "./pages/Patent";
import { DuplicatesFinder } from "./pages/Duplicates";
import { Brands } from "./pages/Brands";
import { ServiceTypes } from "./pages/ServiceTypes";
import { WhatsApp } from "./pages/WhatsApp";

function App() {
  return (
    <AuthProvider>
      <DirtyProvider>
      <Routes>
        <Route path="/" element={<Patent />} />
        <Route path="/consulta" element={<Patent />} />
        
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        
        <Route path="/generator/files" element={<PDFViewer />} />
        
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/newfile"
          element={
            <ProtectedRoute>
              <Newfile />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/history"
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/newuser"
          element={
            <ProtectedRoute>
              <Newuser />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/users"
          element={
            <ProtectedRoute>
              <ListUsers />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/customers"
          element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/customers/new"
          element={
            <ProtectedRoute>
              <NewCustomer />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/customers/edit"
          element={
            <ProtectedRoute>
              <EditCustomer />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/brands"
          element={
            <ProtectedRoute>
              <Brands />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/services"
          element={
            <ProtectedRoute>
              <ServiceTypes />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/dashboard/duplicates"
          element={
            <ProtectedRoute>
              <DuplicatesFinder />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/whatsapp"
          element={
            <ProtectedRoute>
              <WhatsApp />
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      </DirtyProvider>
    </AuthProvider>
  );
}

export default App;

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  if (token) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};
